import { parse } from 'date-fns';

export function convertDateInputToDateObject(date: string): Date {
  return parse(date, 'yyyy-MM-dd', new Date());
}
